module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-1-selected.fef8b071.png";